import { render, staticRenderFns } from "./DietPlan.vue?vue&type=template&id=3c90cd65"
import script from "./DietPlan.vue?vue&type=script&lang=js"
export * from "./DietPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports